import { UcoastEl } from '@/scripts/core/UcoastEl'
import { TsDOM as q } from '@/scripts/core/TsDOM'
import type { LocationMapModal } from '@/scripts/theme/location-map-modal'

export class FloatingMapTab extends UcoastEl {
	static htmlSelector = 'floating-map-tab'

	private modalId: string = ''
	private trigger?: HTMLButtonElement

	override connectedCallback() {
		super.connectedCallback()
		this.modalId = q.oa(this, 'data-modal-id') ?? ''
		this.trigger = q.os<HTMLButtonElement>('[data-floating-map-tab-trigger]', this)

		if (this.trigger) {
			this.trigger.addEventListener('click', this.handleClick.bind(this))
		}
	}

	private handleClick() {
		if (!this.modalId) return
		const modal = document.getElementById(this.modalId) as LocationMapModal | null
		if (!modal) return
		modal.show(this.trigger as HTMLElement)
	}
}
